import { all } from 'redux-saga/effects';
import authSagas from './auth/sagas';
import appSagas from './app/sagas';
/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 * Creates the main reducer with the asynchronously loaded ones
 *
 * @return {object} combined sagas
 */
function* rootSaga() {
  yield all([...authSagas, ...appSagas]);
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/core/sagas.js